import { ReactNode } from 'react';
import styled from 'styled-components';
import DisplayBranding from '../../../components/ui/display/DisplayBranding';
import { useTranslation } from 'react-i18next';
import { DisplayHeader } from '@components/ui/display/DisplayHeader';

const Container = styled.div`
  flex: 1;

  overflow: auto;
  padding: 2rem;

  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
`;

interface LoginLayoutProps {
  children: ReactNode;
}
const LoginLayout = ({ children }: LoginLayoutProps) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Content>
        <DisplayHeader title={t('Welcome to the Kvdbil Image Upload App')} />

        {children}
      </Content>

      <DisplayBranding />
    </Container>
  );
};

export default LoginLayout;
